import { Lot } from '@prisma/client';
import { Text } from '@radix-ui/themes';
import React, { useState, useRef, useEffect } from 'react';

interface LotDescriptionProps {
    lot: Lot;
}

const LotDescription = ({ lot }: LotDescriptionProps) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const [shouldShowButton, setShouldShowButton] = useState(false);
    const textRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (textRef.current) {
            const lineHeight = parseInt(window.getComputedStyle(textRef.current).lineHeight);
            const height = textRef.current.scrollHeight;
            const lines = height / lineHeight;
            setShouldShowButton(lines > 4);
        }
    }, [lot.description]);

    return (
        <div>
            <div
                ref={textRef}
                className={`relative whitespace-pre-wrap ${!isExpanded && shouldShowButton ? 'max-h-[6em] overflow-hidden' : ''}`}
            >
                <Text className="text-gray-600 italic">{lot.description}</Text>
                {!isExpanded && shouldShowButton && (
                    <div className="absolute bottom-0 w-full h-8 bg-gradient-to-t from-white to-transparent" />
                )}
            </div>
            {shouldShowButton && (
                <button
                    onClick={() => setIsExpanded(!isExpanded)}
                    className="text-foreground hover:text-foreground/60 text-sm mt-2 font-medium transition-colors duration-300"
                >
                    {isExpanded ? 'Show less' : 'Show more'}
                </button>
            )}
        </div>
    );
};

export default LotDescription;